import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {

  Link,

  Redirect,
} from "react-router-dom";


import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";

import { connect } from "react-redux";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";

const Property_owner_free_registration = (props) => {
  const { frontLabelsName } = props.label;
  const { isAuthenticated, loading } = props.auth;
  window.scrollTo({ top: 0 });

  // if (isAuthenticated && !loading) {
  //   return <Redirect to="/dashboard" />;
  // }
  const registerProperty = localStorage.getItem("register_Property")

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
      <div className="row">
          <div className="main-login-new">
            
            <div className="box-new-rg d-flex justify-content-center">
              <div className="col-lg-4 col-md-12">
                <div className="main-new-rg new-rh-ur">
                <div className="row px-4 justify-content-center align-items-center">
              {
                registerProperty == 1? <div className="box1-pr-owner col-lg-12 col-md-12 " style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <h4 style={{textAlign:"center",marginBottom:"30px"}}>
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_register_property_free'
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_register_property_free'
                              )[0]['value'] || 'lbl_register_property_free'
                            : 'lbl_register_property_free'
                          : 'lbl_register_property_free'}
                      </strong>
                    </h4>
                  <div className="d-flex flex-column justify-content-center align-items-center" >
                 
                  <div className="img-pr-owner">
                    <img src="assets/book.svg" alt="book" />
                  </div>
                  <p>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_register_for_free")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_for_free"
                          )[0]["value"] || "lbl_register_for_free"
                        : "lbl_register_for_free"
                      : "lbl_register_for_free"}
                  </p>
                  <ul>
                    <li>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_for_free_info"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_register_for_free_info"
                            )[0]["value"] || "lbl_register_for_free_info"
                          : "lbl_register_for_free_info"
                        : "lbl_register_for_free_info"}
                    </li>
                  </ul>
                  </div>
                  <div className="set-ch-u2 d-flex justify-content-center">
                    <a
                      href="http://dev.saturncube.com/property/owner10/#/"
                      target="_blank"
                      rel="noreferrer"
                      className="link-color-class mt-4"
                    >
               
                      <button className="pr-owner-main mt-4">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_register_for_free"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_register_for_free"
                              )[0]["value"] || "lbl_register_for_free"
                            : "lbl_register_for_free"
                          : "lbl_register_for_free"}
                      </button>
                    </a>
                  </div>
                </div>: registerProperty == 2?<div className="box1-pr-owner col-lg-12 col-md-12 " style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <h4 style={{textAlign:"center",marginBottom:"30px"}}>
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_find_tenant'
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_find_tenant'
                              )[0]['value'] || 'lbl_find_tenant'
                            : 'lbl_find_tenant'
                          : 'lbl_find_tenant'}
                      </strong>
                    </h4>
                  <div className="d-flex flex-column justify-content-center align-items-center" >
                 
                  <div className="img-pr-owner">
                  <img src="assets/customer.svg" alt="book" />
                </div>
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_renters_list")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list"
                        )[0]["value"] || "lbl_renters_list"
                      : "lbl_renters_list"
                    : "lbl_renters_list"}
                </p>
                <ul>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list_info1"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_list_info1"
                          )[0]["value"] || "lbl_renters_list_info1"
                        : "lbl_renters_list_info1"
                      : "lbl_renters_list_info1"}
                  </li>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list_info2"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_list_info2"
                          )[0]["value"] || "lbl_renters_list_info2"
                        : "lbl_renters_list_info2"
                      : "lbl_renters_list_info2"}
                  </li>
                </ul>
                  </div>
                  <div className="set-ch-u2 d-flex justify-content-center">
                  <a
                  href="http://dev.saturncube.com/property/owner10/#/"
                  target="_blank"
                  rel="noreferrer"
                    className="link-color-class"
                >
                  <button className="pr-owner-main mt-4">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_register")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_register")[0][
                            "value"
                          ] || "lbl_register"
                        : "lbl_register"
                      : "lbl_register"}
                  </button>
                </a>
                  </div>
                </div>:<div className="box1-pr-owner col-lg-12 col-md-12 " style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <h4 style={{textAlign:"center",marginBottom:"30px"}}>
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_register_property_agency'
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_register_property_agency'
                              )[0]['value'] || 'lbl_register_property_agency'
                            : 'lbl_register_property_agency'
                          : 'lbl_register_property_agency'}
                      </strong>
                    </h4>
                  <div className="d-flex flex-column justify-content-center align-items-center" >
                 
                  <div className="img-pr-owner">
                  <img src="assets/customer-01.svg" alt="book" />
                </div>
                <p>
                {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_arrange_your_property"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_arrange_your_property"
                        )[0]["value"] || "lbl_arrange_your_property"
                      : "lbl_arrange_your_property"
                    : "lbl_arrange_your_property"}
                </p>
                <ul>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_arrange_your_property_info"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_arrange_your_property_info"
                          )[0]["value"] || "lbl_arrange_your_property_info"
                        : "lbl_arrange_your_property_info"
                      : "lbl_arrange_your_property_info"}
                  </li>
                </ul>
                  </div>
                  <div className="set-ch-u2 d-flex justify-content-center">
                  <Link to="/agency-rent" 
                    className="link-color-class">
                    <button className="pr-owner-main mt-5">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_agency-rent")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_agency-rent"
                            )[0]["value"] || "lbl_agency-rent"
                          : "lbl_agency-rent"
                        : "lbl_agency-rent"}
                    </button>
                  </Link>
                  </div>
                </div>
              }
             
            </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
      
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});
export default connect(mapStateToProps, {})(Property_owner_free_registration);
